import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import './accesoPublicarRegistrarse.css';
import ForgotPassword from './ForgotPassword';

  const AccesoPublicarRegistrarse = () => {
  const navigate = useNavigate();
  const captchaRef = useRef(null);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [showForgot, setShowForgot] = useState(false);

  // Funci�n para procesar el login
  const procesarLogin = async (email, password) => {
    try {
       const response = await fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/login.php`, {
        method: 'POST',
        credentials: 'include', // ← IMPORTANTE: Enviar cookies
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
body: JSON.stringify({
          email: email,
          password: password,
          captcha_token: captchaToken
        })
      });

      const data = await response.json();
      
      if (data.success) {
        return { success: true, user_id: data.user_id };
      } else {
        return { success: false, message: data.message || 'Error desconocido' };
      }
    } catch (error) {
      console.error('Error en procesarLogin:', error);
      return { success: false, message: 'Error de conexi�n' };
    }
  };

  // Verificar si ya est� logueado al cargar el componente
useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_AUTH_CREADOR_URL}/check_session.php`,
          {
            method: 'GET',
            credentials: 'include'
          }
        );
        const data = await response.json();

        if (data.success && data.user_id) {
          navigate('/panel_creador');
        }
      } catch (error) {
        console.error('Error verificando sesión:', error);
      }
    };

    checkSession();
  }, []);

  // Manejar cambios en el formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Manejar env�o del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    const { email, password } = formData;

if (!email.trim() || !password.trim()) {
      setErrorMessage('Por favor, complete todos los campos.');
      return;
    }

    if (!captchaToken) {
      setErrorMessage('Por favor, confirma que no eres un robot.');
      return;
    }

    setIsLoading(true);

    try {
      const result = await procesarLogin(email.trim(), password.trim());
      
      if (result.success) {
        setSuccessMessage('Inicio de sesion exitoso. Redirigiendo...');
        setTimeout(() => {
          navigate('/panel_creador');
        }, 1000);
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      setErrorMessage('Error interno del sistema');
      console.error('Error en handleSubmit:', error);
} finally {
      setIsLoading(false);
      setCaptchaToken(null);
      if (captchaRef.current) {
        captchaRef.current.reset();
      }
    }
  };

return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="body-wrapper">
        <div className="login-container">
          <div className="logo-section">
            <div className="logo-text">Ulalaaa</div>
            <div className="subtitle">Acceso para Publicadores</div>
          </div>
          
          {errorMessage && (
            <div className="error-message">
              <i className="fas fa-exclamation-triangle"></i>
              {errorMessage}
            </div>
          )}
          
          {successMessage && (
            <div className="success-message">
              <i className="fas fa-check-circle"></i>
              {successMessage}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">
                <i className="fas fa-envelope"></i> Email o Usuario
              </label>
              <input 
                type="text" 
                id="email" 
                name="email" 
                placeholder="Ingresa tu email o nombre de usuario"
                value={formData.email}
                onChange={handleInputChange}
                required
                disabled={isLoading}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">
                <i className="fas fa-lock"></i> Contraseña
              </label>
              <input 
                type="password" 
                id="password" 
                name="password" 
                placeholder="Ingresa tu contraseña"
                value={formData.password}
                onChange={handleInputChange}
                required
                disabled={isLoading}
              />
            </div>
            
<div className="captcha-container">
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setCaptchaToken(token)}
                onExpired={() => setCaptchaToken(null)}
                theme="dark"
                hl="es"
              />
            </div>

            <button type="submit" className="login-btn" disabled={isLoading}>
              {isLoading ? 'Ingresando...' : (
                <>
                  <i className="fas fa-arrow-right"></i> INGRESA A TU CUENTA
                </>
              )}
            </button>
          </form>
          
<button
            type="button"
            className="forgot-btn"
            onClick={() => setShowForgot(true)}
          >
            {'\u00BFOlvid\u00E9 mi clave?'}
          </button>

          <button className="register-btn" onClick={() => navigate('/registro_contenido')}>
            REGISTRATE !!! Si eres nueva/o
          </button>

          {showForgot && (
            <ForgotPassword onClose={() => setShowForgot(false)} />
          )}
          
          <div className="back-link">
            <a href="../index.php">
              <i className="fas fa-arrow-left"></i>
              Volver al inicio
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

// Componente principal que envuelve la aplicaci�n
const App = () => {
  return (
    <div className="body-wrapper">
      <AccesoPublicarRegistrarse />
    </div>
  );
};

export default AccesoPublicarRegistrarse;